<template>
  <section class="table-section disp-scroll">
    <table class="answer-list-table" border="1">
      <tr class="table-header">
        <th class="answer-date">回答日</th>
        <th class="star-value">評価</th>
        <th class="seeker">回答者</th>
        <th class="comment">コメント</th>
      </tr>
      <template v-for="(data, index) in questionnaireData" v-bind:index="id">
        <tr :key="data.id">
          <td class="answer-date">
            {{formatTime(data.created_at)}}
          </td>
          <td class="star-value">
            {{data.star_value.toFixed(1)}}
          </td>
          <td class="seeker">
            {{data.seeker_name}}
          </td>
          <td class="comment">
            {{data.comment}}
          </td>
        </tr>
      </template>
    </table>
  </section>
</template>

<script>
export default {
  props: {
    questionnaireData: {
      type: Array,
      required: false,
    },
  },
  methods: {
    formatTime (createdAt) {
      return this.$moment(createdAt).format('YYYY/MM/DD H:mm:ss')
    }
  },
}
</script>

<style lang="scss" scoped>
.answer-list-table {
  font-size: 12px;
  width: 100%;
  table-layout: fixed;
  th, td {
    padding: 8px;
  }
  .answer-date {
    width: 150px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .star-value {
    width: 64px;
  }
  .seeker {
    width: 100px;
  }
  .comment {
    width: 200px
  }
  .center-item-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.empty-tr {
  height: 36px;
}
td {
  word-wrap: break-word;
}
</style>


// WEBPACK FOOTER //
// src/components/ChatBot/organisms/QuestionnaireDataTable.vue